/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */

/**
 * unique identifier for each routes
 */
export enum RouteCodes {
  // main routes
  logon = 'LOGON',
  activate = 'ACTIVATE',
  exit = 'EXIT',
  dummy = 'DUMMY',
  settings = 'SETTINGS',
  outOfOrder = 'OUT-OF-ORDER',
  error = 'ERROR',
  position = 'POSITION',
  reservedArea = 'RESERVED-AREA',
  anonymous = 'ANONYMUS',
  // reserved area children routes
  dashboard = 'DASHBOARD',
  customerData = 'CUSTOMER-DATA',
  // anonymous area
  anonymousSimulation = 'ANONYMUS-SIMULATION',
  onboarding = 'ONBOARDING',
  // position children routes
  welcome = 'WELCOME',
  summary = 'SUMMARY',
  finish = 'FINISH',
  stop = 'STOP',
  quotation = 'QUOTATION',
  quotationCalculate = 'QUOTATION-CALCULATE',
  obligations = 'OBLIGATIONS',
  resolution = 'RESOLUTION',
  recognition = 'RECOGNITION',
  consents = 'CONSENTS',
  documentsRequest = 'DOCUMENTS-REQUEST',
  documentsView = 'DOCUMENTS-VIEW',
  adequacy = 'ADEGUACY',
  contractSigning = 'CONTRACT-SIGNING',
  waiting = 'WAITING',
  customerInfo = 'CUSTOMER-INFO',
  financialData = 'FINANCIAL-DATA',
  notes = 'NOTES',
  tfrReleaseQuote = 'TFR-RELEASE-QUOTE',
  atcChoice = 'ATC-CHOICE',
  cardConfirm = 'CARD-CONFIRM',
  dataCollection = 'DATA-COLLECTION',
  surveyCollection = 'SURVEY-COLLECTION',
  foreigner = 'FOREIGNER',
  usesReport = 'USES-REPORT',
  withdraw = 'WITHDRAW',
  instructions = 'INSTRUCTIONS',
  handoverStart = 'HANDOVER-START'
}
